export default __webpack_public_path__ + "static/media/icon-master-24px.3d587854.svg";